"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreeHandInitials = void 0;
const react_redux_1 = require("react-redux");
const useSearchDebounce_1 = require("../../../../../../../hooks/useSearchDebounce");
const constants_1 = require("../../../../../../../constants/constants");
const scaleFunction_1 = require("../../../../../../../helpers/scaleFunction");
const main_1 = require("../../../../../../../reducers/slices/main");
const react_1 = __importDefault(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const add_signature_1 = require("../../add_signature");
const update_single_element_thunk_1 = require("../../../../../../../reducers/slices/document/thunks/update/update_single_element_thunk");
const FreeHandInitials = ({ element, isEditable = true }) => {
    var _a, _b, _c;
    const dispatch = (0, react_redux_1.useDispatch)();
    const { selectedDocument, documentErrors, documentState, selectedDocumentElements } = (0, react_redux_1.useSelector)((state) => state.documentState);
    const [value, setValue] = (0, useSearchDebounce_1.useSearchDebounce)();
    const stateCheck = documentState === constants_1.TYPE_LINK;
    return (react_1.default.createElement("div", { className: `${stateCheck ? "cursor-pointer" : "cursor-move"} rounded-sm inline-block`, style: {
            width: "100%",
            height: "100%",
        }, onClick: () => {
            var _a;
            // Block interaction if not editable (field belongs to another user)
            if (!isEditable) {
                return;
            }
            if (stateCheck && (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.status) !== "COMPLETED") {
                dispatch((0, main_1.setContentModal)({
                    title: `Free hand initials`,
                    content: (react_1.default.createElement(add_signature_1.AddSignature, { value: (_a = element === null || element === void 0 ? void 0 : element.extra_attributes) === null || _a === void 0 ? void 0 : _a.value, type: "Initials", onClick: (image) => {
                            dispatch((0, update_single_element_thunk_1.update_single_element_thunk)({
                                data: {
                                    document_id: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument._id,
                                    payload: Object.assign(Object.assign({}, element), { extra_attributes: Object.assign(Object.assign({}, element.extra_attributes), { value: image }) }),
                                },
                            })).then((res) => { });
                        } })),
                }));
            }
        } }, ((_a = element === null || element === void 0 ? void 0 : element.extra_attributes) === null || _a === void 0 ? void 0 : _a.value) && ((_b = element === null || element === void 0 ? void 0 : element.extra_attributes) === null || _b === void 0 ? void 0 : _b.value) !== "" && stateCheck ? (react_1.default.createElement("img", { src: (_c = element === null || element === void 0 ? void 0 : element.extra_attributes) === null || _c === void 0 ? void 0 : _c.value })) : (react_1.default.createElement("div", { className: `flex gap-2 justify-center items-center border-dashed border ${documentErrors.find((x) => x === element._id) ? "border-error" : "border-superDark"} bg-white`, style: {
            padding: `${(0, scaleFunction_1.scaleFunction)(8)}px`,
            width: "100%",
            height: "100%",
            boxSizing: "border-box",
        } },
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faSignature, className: "font-bold text-black", style: { fontSize: `${(0, scaleFunction_1.scaleFunction)(24)}px` } }),
        !constants_1.IS_MOBILE && (react_1.default.createElement("span", { className: "text-black", style: { fontSize: `${(0, scaleFunction_1.scaleFunction)(14)}px` } }, "Initials"))))));
};
exports.FreeHandInitials = FreeHandInitials;
